import React from 'react'
import { URL_CTRL_TRASP } from '../../router/Url'

export const CrudUsers = ({data, action}) => {
    // console.log(data, action)
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_CTRL_TRASP+'crud_usuarios',{
            method: 'POST',
            headers: {
                'authorization': "paico2021",
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data, action
            })
        })
        let responsito = await query.json();
        // console.log(responsito)
    
        if(responsito.success){
            resolve(responsito.body)
        }else{
            resolve(responsito.body)
        }
    })
}
